import { Lock, Unlock } from 'lucide-react';
import { canTakeOver, lockMessage, type LockState } from '../../lib/edit-lock-state';

/**
 * Franja que explica por qué un formulario está en solo lectura.
 *
 * No bloquea la pantalla ni tapa el contenido: se pone encima del formulario y deja ver los datos.
 * Si el bloqueo es del mismo usuario en otra pestaña, ofrece recuperarlo.
 */
export function EditLockBanner({ state, onTakeOver, onRetry }: {
  state: LockState;
  onTakeOver?: () => void;
  onRetry?: () => void;
}) {
  const mensaje = lockMessage(state);
  if (!mensaje) return null;

  const estilos = {
    info: 'border-sky-200 bg-sky-50 text-sky-900',
    warning: 'border-amber-200 bg-amber-50 text-amber-900',
    danger: 'border-red-200 bg-red-50 text-red-900'
  }[mensaje.tone];

  const Icono = mensaje.tone === 'info' ? Unlock : Lock;

  return (
    <div
      role="status"
      aria-live="polite"
      className={`flex items-start gap-2 rounded-md border px-3 py-2 text-sm ${estilos}`}
    >
      <Icono className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <span className="flex-1">{mensaje.text}</span>
      {canTakeOver(state) && onTakeOver && (
        <button type="button" onClick={onTakeOver} className="shrink-0 font-medium underline underline-offset-2">
          Continuar editando aquí
        </button>
      )}
      {(state.status === 'lost' || state.status === 'error') && onRetry && (
        <button type="button" onClick={onRetry} className="shrink-0 font-medium underline underline-offset-2">
          Volver a intentarlo
        </button>
      )}
    </div>
  );
}
